import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ModalBaseModule } from 'Angular/features/components/modals/modal-base/modal-base.module';
import { OpenItemModalModule } from 'Angular/features/components/saved-items/open-item-modal/open-item-modal.module';
import { IconModule } from 'Angular/features/directives/icon/icon.module';
import { TooltipModule } from 'Angular/features/directives/popovers/tooltip/tooltip.module';
import { MetricSelectorModalModule } from 'CalculationsApp/ts/features/metric-selector-modal/metric-selector-modal.module';
import { InfoFieldSelectorModalModule } from 'SecuritiesApp/ts/info-field-selector-modals/info-field-selector-modal.module';

import { EditDataColumnsModalComponent } from './edit-data-columns-modal.component';

@NgModule({
    imports: [
        CommonModule,
        InfoFieldSelectorModalModule,
        MetricSelectorModalModule,
        ModalBaseModule,
        IconModule,
        TooltipModule,
        OpenItemModalModule,
    ],
    declarations: [EditDataColumnsModalComponent],
    exports: [EditDataColumnsModalComponent],
})
export class EditDataColumnsModalModule {}
